import { useEffect, useState } from 'react';

export interface TimedMessageStep {
  afterSeconds: number;
  text: string;
}

interface Params {
  schedule: TimedMessageStep[];
}

const TICK_INTERVAL = 1000;

const pickText = (schedule: TimedMessageStep[], elapsedSeconds: number): string => {
  const reached = schedule.filter((step) => elapsedSeconds >= step.afterSeconds);
  return reached.length > 0 ? reached[reached.length - 1].text : '';
};

export const useTimedMessage = ({ schedule }: Params): string => {
  const [mountedAt] = useState(() => Date.now());
  const [now, setNow] = useState(mountedAt);

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), TICK_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const elapsedSeconds = Math.max(0, Math.floor((now - mountedAt) / 1000));

  return pickText(schedule, elapsedSeconds);
};
